var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { Form } from '@tribeplatform/react-components/Form';
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
import { MarkdownBlock } from '../Markdown/Block.js';
export const TextareaBlock = forwardRef((props, ref) => {
    const { value: defaultValue, helperText: markdownHelperText, children } = props, rest = __rest(props, ["value", "helperText", "children"]);
    const formContext = useFormContext();
    const { control: enabled, watch } = formContext || {};
    const value = enabled ? watch(rest.name, defaultValue) : defaultValue;
    const helperText = typeof markdownHelperText === 'string' ? (React.createElement(MarkdownBlock, { text: markdownHelperText })) : (markdownHelperText);
    const additionalProps = enabled ? {} : { value };
    const Component = enabled ? Form.Textarea : FormControl.Textarea;
    return (React.createElement(Component, Object.assign({}, rest, additionalProps, { ref: ref, helperText: helperText, defaultValue: value })));
});
//# sourceMappingURL=Block.js.map